export const ROUTES = {
  // Public routes
  HOME: "/",
  OUR_TEAM: "/our-team",
  COLLEGE_FINDER: "/college-finder",
  PUBLIC_FINANCE: "/public-finance",
  LOAN_CALCULATOR: "/loan-calculator",
  DEMOS: "/demos",
  PRICING: "/pricing",
  COMMUNITY: "/community",
  PRIVACY_POLICY: "/privacy-policy",
  BLOG: "/blog/category",
  BLOG_SINGLE: "/blog/post/:blogId",
  COLLEGE_FINDER_NEXT: "/college-finder?next=:next",
  PUBLIC_SCHOLARSHIP: "/public-scholarship",
  VERIFY_EMAIL: "/verify-email",
  TERMS: "/terms",
  LOGIN: "/login",

  // Protected routes
  DASHBOARD: "/dashboard",
  READINESS_CALCULATOR: "/readiness-calculatorForm",
  COLLEGE_COMPARE: "/college-compare",
  COLLEGES: "/colleges",
  FINANCE: "/finance",
  FINANCE_FLOW: "/finance-flow",
  LOAN_ELIGIBILITY: "/loan-eligibility",
  DOCUMENT_UPLOAD: "/document-upload",
  PHONE: "/phone",
  FINANCE_SCHOLARSHIP: "/scholarships",
  CHAT_BOT: "/chatbot",
  CONNECT_OG: "/connectOG",
  CONNECT_OG_FILTERS: "/connectOG/filters",
  CONNECT_OG_PROFILES: "/connectOG/profiles",
  CONNECT_OG_PROFILE_DETAILS: "/connectOG/profile/:profileId",
  USER_PROFILE: "/user-profile",

  PAYMENT: "/payment",

  SCHEDULE_FINANCE_CALL: "/schedule-finance-call",

  // Payment processing routes
  STRIPE_PAYMENT_PROCESSING: "/payment/stripe/processing/:sessionId",
  PHONEPE_PAYMENT_PROCESSING:
    "/payment/phonePe/processing/:merchantTransactionId",
  PAYMENT_FAILED: "/payment/failed",
};

// Helper function to generate dynamic routes
export const generateRoute = {
  stripeProcessing: (sessionId) =>
    ROUTES.STRIPE_PAYMENT_PROCESSING.replace(":sessionId", sessionId),
  phonePeProcessing: (merchantTransactionId) =>
    ROUTES.PHONEPE_PAYMENT_PROCESSING.replace(
      ":merchantTransactionId",
      merchantTransactionId,
    ),
  profileDetails: (profileId) =>
    ROUTES.CONNECT_OG_PROFILE_DETAILS.replace(":profileId", profileId),
};
